import { render, staticRenderFns } from "./TiersImport.vue?vue&type=template&id=52b223e8&"
import script from "./TiersImport.vue?vue&type=script&lang=js&"
export * from "./TiersImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports